export const HeadingSkeleton = (): JSX.Element => {
    return <h1 className="h-4 w-32 bg-slate-200 animate-pulse rounded">{''}</h1>
}

export const TextBlockSkeleton = (): JSX.Element => {
    return (
        <div className="flex flex-col">
            <span className="h-2 w-80 mt-1 bg-slate-200 animate-pulse rounded"></span>
            <span className="h-2 w-80 mt-1 bg-slate-200 animate-pulse rounded"></span>
            <span className="h-2 w-80 mt-1 bg-slate-200 animate-pulse rounded"></span>
            <span className="h-2 w-80 mt-1 bg-slate-200 animate-pulse rounded"></span>
            <span className="h-2 w-80 mt-1 bg-slate-200 animate-pulse rounded"></span>
        </div>
    )
}

interface ImgSkeletonProps {
    rounded?: boolean | string;
    height?: number;
    width?: number | string;
}

export const ImgSkeleton = ({ rounded = true, height, width }: ImgSkeletonProps): JSX.Element => {
    return (
        <span
            className={`h-9 w-9 animate-pulse bg-slate-200 block ${rounded}`}
            style={{ height: height ?? 36, width: width ?? 36, borderRadius: rounded === true ? '50%' : (typeof rounded === "string" ? '' : '0.625rem') }}
        ></span>
    )
}

interface SpanSkeletonProps {
    width?: string;
}

export const SpanSkeleton = ({ width = undefined }: SpanSkeletonProps): JSX.Element => {
    return <span className={`h-2 ${width ?? ' w-8'} bg-slate-200 animate-pulse rounded mt-1`}>{''}</span>
}